import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, Modal,
} from 'reactstrap';
import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import avatar from '../../assets/images/users/anon2.png';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import { post } from '../../helpers/api_helper';
import UserForm from '../../components/User/form';
import * as url from '../../helpers/url_helper';

async function resetPassword(row, e) {
  const btn = e.currentTarget;

  btn.disabled = true;
  btn.blur();
  btn.firstChild.classList.toggle('bx-spin');

  try {
    await post(url.POST_PASSWORD_RESET, {
      id: row.id,
      password: '',
    });

    toastr.success(`Password reset for ${row.email}`, 'Success');
  } catch (error) {
    toastr.error(error.message, 'Error');
  } finally {
    btn.disabled = false;
    btn.firstChild.classList.toggle('bx-spin');
  }
}

function Users(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const [formModal, setFormModal] = React.useState(false);
  const [entity, setEntity] = React.useState({});
  const [signal, setSignal] = React.useState(0);

  const toggle = () => {
    setFormModal(!formModal);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="8">
            <Card>
              <CardHeader className="bg-transparent border-bottom">{props.t('Users')}</CardHeader>
              <CardBody>
                <Can i="see" this="Users">
                  <BaseGrid
                    url="/api/user"
                    hasSearch
                    shouldUpdate={signal}
                    create={() => { setEntity({}); setFormModal(true); }}
                    className="table table-sm table-hover table-striped table-bordered fs-6"
                    config={
                    {
                      columns: {
                        thumb: {
                          label: 'Avatar',
                          image: {
                            src: (item) => item.profile_image || avatar,
                            class: 'rounded',
                            style: { maxHeight: '3rem', maxWidth: '3rem' },
                          },
                          translate: false,
                        },
                        id: { label: 'ID', sort: true, style: { fontSize: '10px' } },
                        real_name: { label: 'Real Name', sort: true, style: { fontSize: '10px' } },
                        email: { label: 'Email Address', sort: true, style: { fontSize: '10px' } },
                        roles: {
                          label: 'Roles',
                          sort: false,
                          badges: {
                            class: 'bg-info bg-soft text-dark p-2',
                            split: ',',
                          },
                          style: { fontSize: '10px' },
                        },
                        created_at: {
                          label: 'Created At',
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: process.env.LOCAL_TZ,
                          },
                          style: { fontSize: '10px' },
                        },
                        actions: {
                          label: 'Actions',
                          actions: [
                            {
                              key: 'reset_pass',
                              icon: 'bx bx-reset',
                              class: 'btn btn-sm btn-soft-warning text-dark',
                              alt: 'Reset Password',
                              click: resetPassword,
                            },
                            {
                              key: 'edit',
                              icon: 'bx bx-pencil',
                              class: 'btn btn-sm btn-soft-info text-dark',
                              alt: 'Edit User',
                              click: (user) => { setEntity(user); setFormModal(true); },
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'asc',
                        perPage: 10,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="Users"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal isOpen={formModal} toggle={toggle} size="lg">
          <div className="modal-header">
            <h5 className="modal-title mt-0">{t('Edit User')}</h5>
            <button
              onClick={() => { setFormModal(false); }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <UserForm
              entity={entity}
              onSuccess={() => { setFormModal(false); setSignal(signal + 1); }}
            />
          </div>

          <div className="modal-footer">
            <button
              type="button"
              onClick={() => { setFormModal(false); }}
              className="btn btn-soft-dark"
              data-dismiss="modal"
            >
              {t('Cancel')}
            </button>
            <button
              type="submit"
              form="UserForm"
              className="btn btn-primary"
            >
              {t('Save Changes')}
            </button>
          </div>
        </Modal>
      </div>
    </div>
  );
}

Users.defaultProps = {
  t: (x) => (x),
};

Users.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Users));
